export default {
      id: "unit_dashboard__address-point-usage",
      viewBox: "0 0 33 46",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__address-point",
      toString: function () {
        return this.url;
      }
    }